module.exports = __webpack_public_path__ + "img/serifnew_box24.febe4aee.jpg";